<mat-toolbar color="primary" class="align-h-center">
  <div class="header-wrapper">
    <div class="align-v-center">
      <picture>
        <source
          media="(max-width: 450px)"
          srcset="assets/img/icons/logo-min-white.svg">
        <img
          src="assets/img/icons/logo-white.svg"
          [routerLink]="['/client/dashboard']"
          title="logo"
          alt="logo"
          class="header-logo pointer"/>
      </picture>

      <ng-content select="[slot='left']"></ng-content>
    </div>

    <div class="align-v-center">
      <ng-content select="[slot='center']"></ng-content>
    </div>

    <div class="align-v-center">
      @if(aiChatEnabled) {
        <app-ai-chat-button></app-ai-chat-button>
      }
      <ng-content select="[slot='right']"></ng-content>
    </div>
  </div>
</mat-toolbar>
